import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, BreadcrumbItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const Breadcrumb = (props) => {
  const onRefresh = () => {
    props.onRefresh();
  };

  const onCsvImport = () => {
    props.onCsvImport();
  };

  const onClickButtons = (index) => {
    const onClick = props.onClickButtons[index];
    onClick();
  };

  const { t, i18n } = useTranslation();

  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-flex align-items-center">
          <h4 className="mb-0 font-size-18">{props.title}</h4>
          {props.onRefresh && (
            <button
              type="button"
              disabled={props.loading}
              className="btn btn-sm btn-outline-dark waves-effect"
              style={{ marginLeft: '10px' }}
              onClick={onRefresh}>
              {props.loading ? (
                <i className="bx bx-hourglass bx-spin font-size-16 align-middle mr-2"></i>
              ) : (
                <i className="bx bx-refresh font-size-16 align-middle mr-2"></i>
              )}
              {t('Refresh')}
            </button>
          )}
          {props.onCsvImport && (
            <button
              type="button"
              disabled={props.loading}
              className="btn btn-sm btn-outline-info waves-effect"
              style={{ marginLeft: '10px' }}
              onClick={onCsvImport}>
              <i className="bx bx-import font-size-16 align-middle mr-2"></i>
              Import from CSV
            </button>
          )}
          {props.onClickButtons &&
            props.onClickButtons.map((btn, index) => (
              <button
                key={'ClickButton_' + index}
                type="button"
                disabled={props.loading}
                className="btn btn-sm btn-outline-info waves-effect"
                style={{ marginLeft: '10px' }}
                onClick={() => onClickButtons(index)}>
                <i
                  className={`${props.iconButtons[index]} font-size-16 align-middle mr-2`}></i>
                {props.titleButtons[index]}
              </button>
            ))}
        </div>
      </Col>
    </Row>
  );
};

export default Breadcrumb;
